import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/services/${id}`)
          .then((res) => {
            resolve(res.data.data.service)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // create({commit}, data) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .post('/services', data)
    //       .then((res) => {
    //         resolve(res)
    //       })
    //       .catch((error) => {
    //         reject(error)
    //       })
    //   })
    // },

    // update({commit}, data) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .put(`/services/${data.id}`, data)
    //       .then((res) => {
    //         resolve(res)
    //       })
    //       .catch((error) => {
    //         reject(error)
    //       })
    //   })
    // },

    delete({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/services/${id}`)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    restore({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.put(`/services/${id}/restore`)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getMasterList({commit}, categoryId) {
      return new Promise((resolve, reject) => {
        axios
          .get('/services/master-list', {
            params: {
              // category_id: categoryId,
            },
          })
          .then(res => {
            resolve(res.data.data.datas)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {},
}
